import React from 'react';
import _ from 'lodash';
import { ActivityGroupModalType } from 'utilities/enum-utils';
import { IGroupServiceActivityGroup } from 'src/interfaces/service-interfaces';
import { IActivityGroupUsers } from 'src/interfaces/user-interfaces';
import { openModalFuncType } from '../SessionActivityGroupsPanel';
import { PrimaryButton } from 'common-components/buttons';
import { Text } from 'common-components/typography';
import { ActivityGroup } from 'common-components/activity-groups/listing';
import ActivityGroupPopoverContent from './ActivityGroupPopoverContent';
import MemberPopoverContent from './MemberPopoverContent';
import UnAssignedMemberListing from './UnAssignedMemberListing';
import { timeZone } from 'src/interfaces/timezone-type';
import { Stack } from '../../../../../common-components/stack';

interface IActivityGroupListingProps {
  activityGroups: IGroupServiceActivityGroup[];
  unAssignedMembers: {
    customers: IActivityGroupUsers[];
    teamMembers: IActivityGroupUsers[];
  };
  openModal: openModalFuncType;
  timezone: timeZone;
}

function ActivityGroupListing(props: IActivityGroupListingProps) {
  const { activityGroups, unAssignedMembers, openModal, timezone } = props;
  const { customers, teamMembers } = unAssignedMembers;
  if (_.isEmpty(activityGroups)) return <></>;

  return (
    <>
      <div className="flex-row justify-between align-center mb-x-small">
        <Stack gap="lg">
          <Text weight="bold" size="x2-large">
            Activity groups ({activityGroups.length})
          </Text>
          <div style={{ maxWidth: '62ch' }}>View and manage all groups and activities for this service.</div>
        </Stack>
        <div>
          <PrimaryButton size="large" icon={'plus'} onClick={() => openModal(null, ActivityGroupModalType.CREATE)}>
            {' '}
            Create activity group
          </PrimaryButton>
        </div>
      </div>

      <div
        className="mt-large grid align-start overflow-auto justify-start"
        style={{ gridAutoFlow: 'column', columnGap: '32px' }}
      >
        <UnAssignedMemberListing customers={customers} teamMembers={teamMembers} openModal={openModal} />
        {_.map(activityGroups, (activityGroup: IGroupServiceActivityGroup) => (
          <ActivityGroup
            key={activityGroup.serviceDateTimeActivityGroupId}
            activityGroup={activityGroup}
            activityGroupPopoverContent={
              <ActivityGroupPopoverContent activityGroup={activityGroup} openModal={openModal} />
            }
            MemberPopoverContent={MemberPopoverContent}
            memberPopoverContentProps={{
              activityGroup: activityGroup,
              openModal: openModal,
            }}
            addMember={() => openModal(activityGroup, ActivityGroupModalType.ADD_BOTH)}
            timezone={timezone}
          />
        ))}
      </div>
    </>
  );
}

export default ActivityGroupListing;
